import { Tenant } from '.';

export class Container {
  containerId: number;
  name: string;
  taxYear: number;
  isService: boolean;
  isPlaceholder: boolean;
  tenant?: Tenant;
  tenantId?: number;
  displayName: string;
  containerUuid?: string;
}

export class WorkingContainer {
  workingContainer: number;
}
